import React from "react";

import useTaskCategoryRules from "./hooks/useTaskCategoryRules";

type SupabaseContextType = {
  taskCategoryRules: ReturnType<typeof useTaskCategoryRules>;
};

const SupabaseContext = React.createContext<SupabaseContextType>(null);

const SupabaseProvider = ({ children }) => {
  const taskCategoryRules = useTaskCategoryRules();

  return (
    <SupabaseContext.Provider value={{ taskCategoryRules }}>
      {children}
    </SupabaseContext.Provider>
  );
};
export default SupabaseProvider;

export const useSupabase = () => React.useContext(SupabaseContext);
